let externalShowSnackbar = null;

export const registerSnackbar = (fn) => {
  externalShowSnackbar = fn;
};

export const showSnackbarExternally = (msg, severity = 'error') => {
  if (externalShowSnackbar) {
    externalShowSnackbar(msg, severity);
  } else {
    console.warn('Snackbar externo no está registrado:', msg);
  }
};
